<i18n src="@/locales/views/organization/partners/producers/change_field_owner.yml" lang="yaml" ></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>

<template>
  <go-back-link :text="$t('labels.go_back_link')" name="org_partners_producers_show_producer_path" :params="{
    organization_id: organization_id,
    producer_id: producer_id
  }" />
  <bread-crumbs :labels="[
    module_name,
    producer?.organization_producer?.producer_code,
    crop_field?.organization_crop_field?.crop_field_code,
    crop_field?.name]" />

  <alert-danger :errors_data="std_err" />

  <template v-if="load_general_data">
    <producer-info :producer="producer" :organization_id="organization_id" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <label :class="['label-form', isInvalidLabel('producer')]">
                  {{ $t("model.crop_field.producer_id") }}
                </label>
                <div class="mt-1">
                  <select-form :options="producers" v-model="crop_field.producer_id" label="fullname"
                    :is_invalid="isInvalidSelect('producer')" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button @click.prevent="goToShowProducer()" :label="$t('labels.cancel_button')" />
            <span class="space-actions"></span>
            <success-button v-if="!proc_save_button" @click.prevent="update()" :label="$t('labels.save_button')" />
            <success-button-processing v-else :label="$t('labels.save_button')" />
          </div>
        </div>
      </div>
    </div>
  </template>

  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/partners/producers/change_field_owner.js";

import CropFieldTypesMixin from "@/components/views/mixins/models/crop_field_types.js";

import RequesterManageProducer from "@/views/organization/requesters/partners/producers/manage_producer.js";
import ProducerInfo from "@/components/views/organization/partners/producers/ProducerInfo.vue";

export default {
  name: "OrgPartnersProducersEditCropField",
  mixins: [CropFieldTypesMixin],
  components: { ProducerInfo },
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      producer: {},
      crop_field: {},
      producers: [],
    };
  },
  props: {
    organization_id: {},
    producer_id: {},
    crop_field_id: {}
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchProducer();
      await this.fetchProducers();
      await this.fetchCropField();
      this.load_general_data = true;
    },
    fetchProducer: async function () {
      let response = await RequesterManageProducer.fetchProducer(
        this.organization_id,
        this.producer_id
      );

      this.producer = response.data;
    },
    fetchProducers: async function () {
      let response = await Requester.fetchProducers(this.organization_id);

      this.producers = response.data;
    },
    fetchCropField: async function () {
      let response = await Requester.fetchCropField(
        this.organization_id,
        this.crop_field_id
      );

      this.crop_field = response.data;
    },
    update: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.updateCropField(
          this.organization_id,
          this.crop_field_id,
          this.crop_field
        );

        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProducer(this.crop_field.producer_id);
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
        this.proc_save_button = false;
      }
    },
    goToShowProducer: function (producer_id = this.producer_id) {
      this.$router.push({
        name: "org_partners_producers_show_producer_path",
        params: {
          organization_id: this.organization_id,
          producer_id: producer_id
        }
      });
    }
  },
};
</script>
